import React from "react";
import { Helmet } from "react-helmet";
import "./InformationV2.css";
import graphics1 from "../../assets/imgs/info/graphics (1).png";
import graphics2 from "../../assets/imgs/info/graphics (2).png";
import graphics3 from "../../assets/imgs/info/graphics (3).png";
import graphics4 from "../../assets/imgs/info/graphics (4).png";
import graphics5 from "../../assets/imgs/info/graphics (5).png";
import graphics6 from "../../assets/imgs/info/graphics (6).png";
import graphics7 from "../../assets/imgs/info/graphics (7).png";
import graphics8 from "../../assets/imgs/info/graphics (8).png";

const infoData = [
    {
        title: "Professional Real Estate Websites for Agents & Teams",
        text: "Build a high-impact website crafted for real estate professionals. Perfect for agents, teams, and brokerages—all.",
        image: graphics1,
    },
    {
        title: "Mobile-Optimized & Responsive Design",
        text: "Enjoy a experience on any device. Our responsive design ensures your site looks great on desktop, tablet, or mobile, connecting you with every prospect.",
        image: graphics2,
    },
    {
        title: "Customizable Templates & Complete Control",
        text: "Choose from a variety of stylish templates built for real estate, and manage your site effortlessly with our secure dashboard and intuitive tools.",
        image: graphics3,
    },
    {
        title: "Built-In SEO & Marketing Tools",
        text: "Enhance your online presence with integrated SEO features and marketing tools designed to attract more leads and boost your brand.",
        image: graphics4,
    },
    {
        title: "Affordable, All-Inclusive Plans",
        text: "Have your own website without breaking the bank. Our cost-effective plans provide everything you need to thrive in a competitive market.",
        image: graphics6,
    },
    {
        title: "IDX Integration for Listings",
        text: "Seamlessly display all your MLS listings on your website with our IDX support. Keep your site up-to-date and provide visitors with the latest properties automatically.",
        image: graphics7,
    },
    {
        title: "Social Media Integration & Add-Ons",
        text: "Expand your reach with our social media add-ons. We offer professional management, content creation, and analytics to help you grow your brand across all major platforms.",
        image: graphics8,
    },
];

const InformationV2 = () => {
    return (
        <>
            <Helmet>
                <title>Real Estate Website Features | AptoWebsites</title>
                <meta name="description" content="Discover the features of AptoWebsites: mobile-optimized, SEO-ready, IDX integration, social media add-ons, and more for real estate professionals." />
                <meta name="keywords" content="real estate website features, IDX, SEO, mobile, social media, AptoWebsites" />
                <meta property="og:title" content="Real Estate Website Features | AptoWebsites" />
                <meta property="og:description" content="Discover the features of AptoWebsites: mobile-optimized, SEO-ready, IDX integration, social media add-ons, and more." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/" />
            </Helmet>
            {/* <section className="info-v2-hero">
                <div className="info-v2-hero-inner">
                    <h1 className="info-v2-title">
                        <span>Comprehensive</span> Real Estate Website Features
                    </h1>
                    <p className="info-v2-subtitle">
                        Everything you need to stand out, attract leads, and grow your real estate business online.
                    </p>
                </div>
            </section> */}
            <div className="info-v2-list">
                {infoData.map((section, idx) => (
                    <div className={`info-v2-card${idx % 2 === 1 ? " reverse" : ""}`} key={idx}>
                        <div className="info-v2-image-wrap">
                            <img src={section.image} alt={section.title} className="info-v2-image" />
                        </div>
                        <div className="info-v2-content">
                            <h2>{section.title}</h2>
                            <p>{section.text}</p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default InformationV2;
